<div class="page-content">
    <p-panel header="Groups" class="no-x-padding">
        <app-service-request-group-crud></app-service-request-group-crud>
    </p-panel>
</div>
